import React from "react";
import Earning from "./Earning";

function FormalReport() {
  return (
    <div>
      <Earning />
    </div>
  );
}

export default FormalReport;
